import React, { useState } from "react";
import IPendingItemsOnReleaseItem from "@models/DTO/IPendingItemsOnReleaseItem";
import PendingItemsActionEnum from "@models/PendingItemsActionEnum";
import OwTitle from "@components/shared/OwTitle/OwTitle";
import OwButton from "@components/shared/OwButton/OwButton";
import OwLabel from "@components/shared/OwLabel/OwLabel";
import OwTranslate from "@components/shared/OwTranslate/OwTranslate";
import UIService from "@services/UIService";
import "./PendingItemsOnReleaseModal.scss";

type Props = {
    items: IPendingItemsOnReleaseItem[];
    message?: string;
    cancelFn: () => void;
    onAction: (action: PendingItemsActionEnum) => void;
};

export const PendingItemsOnReleaseModal = (props: Props) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleAction = (action: PendingItemsActionEnum) => {
        setIsSubmitting(true);
        props.onAction(action);
    };

    return (
        <div className="PendingItemsOnReleaseModal">
            <div className="modal-header">
                <OwTitle title="pending_backorder_items" tag="h5" />
            </div>
            <div className="modal-body">
                {props.message ? <p className="text-danger mb-2">{props.message}</p> : null}
                <p className="mb-3">
                    <OwTranslate
                        id="pending_items_on_release_description"
                        defaultMessage="Available inventory will be automatically allocated, but the remaining quantities need your attention."
                    />
                </p>
                <table className={"table table-sm " + (UIService.isMainViewLight() ? "" : "table-dark")}>
                    <thead>
                        <tr>
                            <th>
                                <OwLabel title="item" noBottomMargin={true} />
                            </th>
                            <th>
                                <OwLabel title="sku" noBottomMargin={true} />
                            </th>
                            <th>
                                <OwLabel title="order_qty" noBottomMargin={true} />
                            </th>
                            <th>
                                <OwLabel title="pending" noBottomMargin={true} />
                            </th>
                            <th>
                                <OwLabel title="can_fulfill" noBottomMargin={true} />
                            </th>
                            <th>
                                <OwLabel title="still_pending" noBottomMargin={true} />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.items.map((item) => (
                            <tr key={item.orderItemId}>
                                <td>{item.catalogItemName}</td>
                                <td>{item.catalogItemSku}</td>
                                <td>{item.qty}</td>
                                <td>{item.qtyPending}</td>
                                <td>{item.qtyFulfillable}</td>
                                <td className={item.qtyStillPending > 0 ? "text-warning fw-bold" : ""}>{item.qtyStillPending}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="modal-footer">
                <OwButton title="cancel" fn={props.cancelFn} className="btn-secondary" disabled={isSubmitting} />
                <OwButton
                    title="create_backorder"
                    fn={() => handleAction(PendingItemsActionEnum.BACKORDER)}
                    className="btn-primary"
                    disabled={isSubmitting}
                />
                <OwButton
                    title="remove_items"
                    fn={() => handleAction(PendingItemsActionEnum.REMOVE)}
                    className="btn-warning"
                    disabled={isSubmitting}
                />
                <OwButton
                    title="zero_out_and_add_note"
                    fn={() => handleAction(PendingItemsActionEnum.ZERO_OUT)}
                    className="btn-danger"
                    disabled={isSubmitting}
                />
            </div>
        </div>
    );
};
